<template>
  <div class="jc-page-container" id="billOverview">
    <div class="jc-page-header">
      <el-page-header title="渠道账单总览" />
    </div>

    <div class="jc-page-content">
      <el-alert
        class="mb-16px"
        title="注：账单总览为按月汇总的消费数据，本月数据可能会有延迟，实时数据请您查看明细账单；"
        type="warning"
        :show-icon="false"
        :closable="false"
      />

      <div class="jc-page-card pb-0px">
        <el-form
          :inline="true"
          :model="overviewForm"
          ref="form"
          class="jc-list__form"
        >
          <el-form-item label="账期:" prop="date">
            <DateSelect v-model="overviewForm.billDate" />
          </el-form-item>
          <el-form-item label="渠道账户:" prop="type">
            <UserSelect
              v-model="overviewForm.pin"
              class="w-500px"
              :filterable="true"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="flex">
        <div class="jc-page-card pb-0px min-w-312px mr-16px h-460px">
          <el-form ref="form" label-width="70%" label-position="left">
            <el-form-item label="应付费用" prop="actualFee">
              ¥ {{ feeList.actualFee }}
            </el-form-item>

            <el-form-item label="原价" prop="billFee">
              ¥ {{ feeList.billFee }}
            </el-form-item>

            <el-form-item label="优惠金额" prop="discountFee">
              ¥ {{ feeList.discountFee }}
            </el-form-item>

            <el-form-item label="现金支付" prop="cashPayFee">
              ¥ {{ feeList.cashPayFee }}
            </el-form-item>

            <el-form-item label="付费代金券" prop="payCouponFee">
              ¥ {{ feeList.payCouponFee }}
            </el-form-item>

            <el-form-item label="免费代金券" prop="freeCouponFee">
              ¥ {{ feeList.freeCouponFee }}
            </el-form-item>
            <el-form-item label="欠费金额" prop="arrearFee">
              ¥ {{ feeList.arrearFee }}
            </el-form-item>
            <el-form-item label="计入业绩" prop="performanceFee">
              ¥ {{ feeList.performanceFee }}
            </el-form-item>
          </el-form>
        </div>

        <div class="jc-page-card pb-0px w-full h-460px">
          <span class="text-20px">近6个月费用趋势</span>

          <el-tabs v-model="activeName">
            <el-tab-pane label="业绩" name="performanceFee" />

            <el-tab-pane label="按应付费用" name="actualFee" />

            <el-tab-pane label="按原价" name="billFee" />

            <el-tab-pane label="现金" name="cashPayFee" />

            <el-tab-pane label="付费代金券" name="payCouponFee" />

            <el-tab-pane label="免费代金券" name="freeCouponFee" />
          </el-tabs>

          <BarLineChart
            v-if="lastSixMonthOriginData.length"
            style="width: 100%"
            :xAxisData="xAxisData"
            :yAxisData="yAxisData"
          />
        </div>
      </div>

      <!-- 账单汇总start -->
      <div class="jc-page-card">
        <div class="text-24px">{{ title }}</div>

        <el-tabs v-model="billName">
          <el-tab-pane label="按产品汇总" name="product" />
          <el-tab-pane label="按账号汇总" name="pin" />
          <el-tab-pane label="按账号和产品汇总" name="productAndPin" />
          <el-tab-pane
            label="按下级渠道商汇总"
            name="distributor"
            v-if="distributorLevel === 0 && overviewForm.pin === ''"
          />
        </el-tabs>

        <template v-if="billName === 'product'">
          <OverviewList :dataList="dataList" :overviewForm="overviewForm" />
          <div class="jc-list__action-bar mt-16px">
            <div class="jc-list__action-bar--right">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :current-page="listForm.pageIndex"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <summary-product-and-pin
            :type="billName"
            :filter-params="overviewForm"
          ></summary-product-and-pin>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  toRefs,
  watchEffect,
  watch,
} from '@vue/composition-api'
import {
  describeBillSummary,
  describeBillSummaryTrend,
  describeBillSummaryDetail,
} from '@/api/channel-api.js'
import DateSelect from '@/views/channel/components/DateSelect.vue'
import BarLineChart from '@/views/channel/components/BarLineChart.vue'
import OverviewList from '@/views/channel/components/OverviewList.vue'
import UserSelect from '@/views/channel/components/UserSelect.vue'
import SummaryProductAndPin from '@/views/channel/components/SummaryProductAndPin.vue'
import store from '@/stores/index'
export default {
  // 组件名称
  name: 'billOverview',
  props: {},
  components: {
    SummaryProductAndPin,
    DateSelect,
    BarLineChart,
    OverviewList,
    UserSelect,
  },
  setup() {
    const state = reactive({
      overviewForm: {
        billDate: '',
        pin: '',
      },
      listForm: {
        pageIndex: 1,
        pageSize: 10,
      },
      partnerUserDTOList: [],
      feeList: {},
      activeName: 'performanceFee',
      billName: 'product',
      chartOption: {
        grid: {
          containLabel: true,
          left: '2%',
          right: '2%',
          top: '5%',
          bottom: 24,
        },
        legend: {
          bottom: '0%',
          itemGap: 30,
          itemWidth: 14,
          inactiveColor: 'rgba(0, 0, 0, 0.38)',
          textStyle: {
            color: 'rgba(0, 0, 0, 0.87)',
          },
        },
        xAxis: {
          data: [],
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.12)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: 'rgba(0, 0, 0, 0.87)',
          },
        },
      },
      lastSixMonthOriginData: [],
      xAxisData: [],
      yAxisData: [],
      total: 0,
      dataList: [],
      distributorLevel: store.state.distributor.distributorLevel,
    })
    const getExpenseSummary = async () => {
      if (!state.overviewForm.billDate) {
        return
      }
      const {
        result: { result },
      } = await describeBillSummary({
        params: {
          queryTimeType: 'month',
          ...state.overviewForm,
        },
      })
      state.feeList = result
    }
    const getLastSixMonthData = async () => {
      try {
        if (!state.overviewForm.billDate) {
          return
        }
        const {
          result: { result },
        } = await describeBillSummaryTrend({
          params: {
            ...state.overviewForm,
            range: 6,
          },
        })
        state.lastSixMonthOriginData = result || []
      } catch {
        state.lastSixMonthOriginData = []
      }
    }
    const getBillDataList = async () => {
      try {
        if (!state.overviewForm.billDate) {
          return
        }
        const {
          result: { result, pagination },
        } = await describeBillSummaryDetail({
          params: {
            ...state.overviewForm,
            ...state.listForm,
          },
        })
        state.dataList = result
        state.total = pagination.numberRecords
      } catch {
        state.dataList = []
        state.total = 0
      }
    }
    const handleSizeChange = (val) => {
      state.listForm.pageSize = val
    }
    const handleCurrentChange = (val) => {
      state.listForm.pageIndex = val
    }
    const title = computed(() => {
      return state.overviewForm.billDate.replace(
        /(\d{4})-(\d{2})/,
        (match, year, month) => {
          return `${year}年 ${parseInt(month)}月账单汇总`
        },
      )
    })
    watchEffect(() => {
      getExpenseSummary()
      getLastSixMonthData()
    })
    watchEffect(() => {
      if (state.billName === 'product') {
        getBillDataList()
      }
    })
    watch(
      [() => state.lastSixMonthOriginData, () => state.activeName],
      (val) => {
        state.xAxisData = val[0].map((ele) => ele.billDate)
        state.yAxisData = val[0].map((ele) => ele[state.activeName])
      },
      {
        deep: true,
      },
    )
    watch(
      () => state.overviewForm.pin,
      (val) => {
        if (val !== '' && state.billName === 'distributor') {
          state.billName = 'product'
        }
      },
      {
        deep: true,
      },
    )
    getExpenseSummary()
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      title,
    }
  },
}
</script>
